export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";